<template>
    <el-popover
        v-model:visible="isVisible"
        :width="width"
        class="cardStyled"
        :popper-style="popperStyle"
        :trigger="trigger"
        :placement="placement"
    >
        <template #reference>
        <div @click.stop="togglePopover" class="referenceBox">
            <slot name="reference">
                <div class="trigger-btn" :style="btnStyles">
                    <IconComponent class="trigger-icon" v-if="icon" :icon="icon" />
                </div>
            </slot>
        </div>
        </template>
    
        <template #default>
        <div class="basePopover"> 
            <div
              v-for="(item, index) in filteredMenuItems"
              :key="index"
              class="baseItemInfo"
              :class="item.class"
              @click="handleAction(item.action)"
              >
              <IconComponent v-if="item.icon" :icon="item.icon" class="menuIcon" noRtlTransform/>
              <h2>{{ item.text }}</h2>
            </div>
        </div>
        </template>
    </el-popover>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  menuItems: {
    type: Array,
    required: true,
  },
  icon: {
    type: String,
    default: '',
  },
  popoverKey: {
    type: String,
    default: '',
  },
  width: {
    type: Number,
    default: 180,
  },
  trigger: {
    type: String,
    default: 'click',
  },
  btnStyles: {
    type: Object,
    default: () => ({}),
  },
  popperStyle: {
    type: String,
    default: `
      box-shadow: -2px 3px 18px 0px rgba(75,70,92,0.1) !important;
      
      border-radius: 10px;
      min-width: 180px;
      padding: 8px 0;
        display: grid;
        gap: 10px;
    `,
  },
  placement: {
    type: String,
    default: 'bottom-start',
  },
});

const isVisible = ref(false);

const togglePopover = () => {
    setTimeout(() => {
        isVisible.value = !isVisible.value;
    })
};

const handleAction = (action) => {
  if (typeof action === 'function') {
    action();
  }
  isVisible.value = false;
};

const filteredMenuItems = computed(() => {
  if (!props.menuItems || !Array.isArray(props.menuItems)) {
    return [];
  }
  return props.menuItems.filter((item) => item.condition);
});
</script>

<style scoped lang="scss">

.basePopover {
    .baseItemInfo {
        display: flex;
        align-items: center;
        padding: 6px 16px;
        text-decoration: none;
        color: var(--base-text-white);
        font-size: var(--font-xs);
        gap: 10px;
      .newiconDv {
        width: 15px;
        height: 15px;
        margin-inline-end: 0!important;
      }

      h2 {
        cursor: pointer;
        text-align: left;
        font-size: var(--font-xs);
        color: var(--text-color);
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0px;
        margin: 0px;
        padding: 0px;
        display: flex;
        align-items: center;
        font-weight: 400 !important;
        .svg_icon {
          width: 12px;
          height: 12px;
          margin-inline-end: 10px;
        }
      }

      &:last-child {
        border-bottom: 0px solid;
      }

      &:focus,
      &:hover {
        background: var(--base-regular) !important;
      }
    }
  }

.trigger-icon {
    width: 15px;
    height: 15px;
    :deep(svg) {
        path {
            fill: var(--base-text);
        }
    }
}
.menuIcon {
  width: 16px;
  height: 16px;
  margin-inline-end: 0px !important;
}
.popover-wrapper {
    width: 30px;
    height: 30px;
}
@media only screen and (min-width: 1280px) and (max-width: 1891px) {
  .trigger-btn {
      max-width: 30px !important;
      max-height: 30px !important;
  }
}
</style>
